import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";
import { handleTextResponse } from "@/helpers/HandleResponses";
import handleBlobResponse from "@/helpers/HandleBlobResponses";

export const employeeService = {
  addEmployee,
  addEmployeeManager,
  addEmployeeManagerII,
  addOperationalEmployeeManager,
  addOperationalEmployeeManagerII,
  changeEmployeePhoto,
  addEmployeeExperience,
  addEmployeeEducation,
  addEmployeeGLI,
  addEmployeeNextOfKin,
  addEmployeeEmergency,
  addEmployeeBank,
  addEmployeeFamily,
  addEmployeeStatutory,
  grantEmployee,
  getGroups,
  onboard,
  updateEmployee,
  updateEmployeeExperience,
  updateEmployeeEducation,
  updateEmployeeGLI,
  updateEmployeeNextOfKin,
  updateEmployeeEmergency,
  updateEmployeeBank,
  updateEmployeeFamily,
  updateEmployeeStatutory,
  getEmployeeLeaveSummary,
  getEmployeeLeavesByManager,
  getEmployees,
  getAllEmployees,
  getEmployeesByDepart,
  getExitEmployees,
  getEmployeeDetail,
  getEmployeeOtherDetail,
  removeEmployee,
  removeEmployeeEducation,
  removeEmployeeGLI,
  removeEmployeeNextOfKin,
  removeEmployeeExperience,
  removeEmployeeFamily,
  removeEmployeeEmergency,
  updateEmployeePersonalInfo,
  updateEmployeeProfileInfo,
  removeEmployeePension,
  addEmployeeLeave,
  getEmployeeLeaves,
  getEmployeeLeavesByEmployee,
  getEmployeeLeaveEligibility,
  getEmployeePolicies,
  updateEmployeeLeave,
  removeEmployeeLeave,
  addEmployeeLeavePolicy,
  deleteEmployeeLeavePolicy,
  addEmployeeResignation,
  getEmployeeResignations,
  getEmployeeResignation,
  getEmployeeResignationsByEmployee,
  updateEmployeeResignation,
  removeEmployeeResignation,
  getEmployeeTerminations,
  addEmployeeTermination,
  updateEmployeeTermination,
  removeEmployeeTermination,
  getEmployeeSalary,
  addEmployeeSalary,
  exitEmployee,
  reconsiderEmployee,
  exitAutoEmployee,
  updateEmployeeSalary,
  removeEmployeeSalary,
  addEmployeePromotion,
  getPromotions,
  removeEmployeePromotion,
  updateEmployeePromotion,
  addExpenseClaim,
  addExpenseClaimItem,
  approveExpenseClaim,
  addCashAdvance,
  approveCashAdvance,
  approveEmployeeLeave,
  approveLoanRequest,
  addCashRetirement,
  addCashRetirementLine,
  addCashRetirementLink,
  getExpenseClaims,
  getExpenseClaimByUnit,
  getExpenseClaimByEmployee,
  getExpenseClaimByTeam,
  getExpenseClaimById,
  getCashAdvances,
  getCashAdvanceByUnit,
  getCashAdvanceByEmployee,
  getCashAdvanceByTeam,
  getCashAdvanceById,
  getCashRetirementByUnit,
  getCashRetirementByTeam,
  getEmployeeSalaries,
  getPaidSalaries,
  addDisciplinaryMeasure,
  getDisciplinaryMeasureByEmployeeId,
  getDisciplinaryMeasures,
  updateDisciplinaryMeasure,
  removeDisciplinaryMeasure,
  addDisciplinaryCase,
  getDisciplinaryCaseByEmployeeId,
  getDisciplinaryCases,
  updateDisciplinaryCase,
  removeDisciplinaryCase,
  addQuery,
  removeQuery,
  updateQuery,
  getQuery,
  getLookup,
  getQueries,
  getallEmployeeSalaries,
  getDesignation,
  addExitInterview,
  UpdateExitInterview,
  addRetireExitInterview,
  UpdateRetireExitInterview,
  addEmployeeActivity,
  addEmployeeResource,
  UpdateEmployeeActivity,
  UpdateEmployeeResource,
  removeEmployeeActivity,
  removeEmployeeResource,
  getHRLeaveSummary,
  getDashboardCountSummary,
  getTodayAbsence,
  getManagers,
  getManager,
  getOperationalManagers,
  getOperationalManager,
  getUpcomingLeaves,
  getUpcomingResignations,
  getLastSalaryPayment,
  queryResponse,
  exportEmployee,
  importEmployee,
  importEmployeeDetail,
  importEmployeeSalary,
  exportEmployeeSalary,
  exportPrevEmployeeSalary,
  exportAllTempPayslip,
  downloadEmployeeTemplate,
  downloadOnboardingTemplate,
  downloadEntitlementTemplate,
  downloadEmployeeSalaryTemplate,
  getApprovedCashAdvances,
  getApprovedExpenseClaims,
  getCompletedCashAdvances,
  getCompletedExpenseClaims,
  getPostedExpenseClaims,
  getPostedCashAdvances,
  addExpenseType,
  updateExpenseType,
  updateExpenseClaim,
  updateExpenseClaimItem,
  adjustExpenseClaimItems,
  updateCashAdvance,
  updateCashRetirement,
  updateCashRetirementLine,
  updateCashRetirementLink,
  getExpenseType,
  removeExpenseClaim,
  removeExpenseClaimItem,
  removeExpenseType,
  removeCashAdvance,
  removeCashRetirement,
  removeCashRetirementLine,
  removeCashRetirementLink,
  importOnboarding,
  addEmployeeRetirement,
  getEmployeeRetirements,
  getEmployeeRetirementsByEmployee,
  removeEmployeeRetirement,
  updateEmployeeRetirement,
  getHires,
  getHire,
  getTodayBirthdays,
  getUpcomingBirthday,
  getThirdRaterGoals,
  getUpcomingHolidays,
  isEmployeeManager,
  isOperationalEmployeeManager,
  importLeaveEntitlement,
  checkMgt,
  getEmployeeDepartLeaves,
  getEmployeeDepartLoans,
  addEmployeeAmedLeave,
  getAmendedLeaves,
  getDepartAmendedLeaves,
  getAmendedLeavesByManager,
  updateLeaveAmendment,
  UpdateEmployeeOnboarding,
  GetProbatedEmployees,
  getEmployeeById,
  extendProbationTo,
  updateProbatedEmployeeOnConfirmation,
  GetProbatedEmployeesByUnit,
  updateProbatedEmployee,
  GetProbatedEmployeesExtension,
  updateProbatedEmployeeExtension,
  GetTransferedEmployees,
  GetTransferedEmployeesByDepart,
  GetTransferedEmployeesByIncoming,
  addTransferedEmployee,
  updateTransferedEmployee,
  confirmTransferedEmployee,
  removeLeaveEntitlement,
  addLoanRequest,
  calculateLoan,
  addLoanType,
  getLoanTypes,
  getLoanRequests,
  getLoanRequestsByEmployee,
  getLoanRequestsByTeam,
  getLoanRequestsByUnit,
  getCurrentLoanRequestsByUnit,
  updateLoanRequest,
  UpdateLoanToPayroll,
  updateLoanType,
  removeLoanType,
  removeLoanRequest,
  addStoreRequisition,
  addStoreRequisitionItem,
  updateStoreRequisition,
  updateStoreRequisitionItem,
  removeStoreRequisition,
  removeStoreRequisitionItem,
  getStoreRequisitionByEmployee,
  getStoreRequisitionByTeam,
  getStoreRequisitions,
  getStoreRequisitionById,
  addPurchaseRequisition,
  addPurchaseRequisitionItem,
  updatePurchaseRequisition,
  updatePurchaseRequisitionItem,
  removePurchaseRequisition,
  removePurchaseRequisitionItem,
  getPurchaseRequisitionByEmployee,
  getPurchaseRequisitionByTeam,
  getPurchaseRequisitions,
  getPurchaseRequisitionById,
  deleteEmployeeEducation,
  getProducts,
  getAmountByLoanType,
  getLeavesApprovals,
  getLoanApprovals,
  getPrevAllowanceLeaves,
  getRecentDiscipline,
  uploadFile,
  getBankAccounts,
  completeExpenses,
  completeCashAdvance,
  exportAdvance,
  exportClaim,
  exportAllLeaves,
  addRetireExitDocument,
  addExitDocument,
  addLoans,
  exportCertificate,
  checkLoan
};

// function addEmployeeResignation(id, employeeId, designationId, name, reason, noticeDate, resignationDate) {
//     var data = {
//         id, employeeId, name, reason, noticeDate, resignationDate, designationId,
//     }
//     return fetch(`${config.apiurl}/Employee/PostEmployeeResignation`, requestOptions.post(data))
//         .then(handleResponse)
//         .then(id => {
//             return id;
//         })
// }

function getEmployeeResignation(id) {

    return fetch(`${config.apiurl}/Employee/GetEmployeeResignation/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(model => {

            return model
        });

}

function addEmployee(
  companyId,
  rankId,
  firstName,
  lastName,
  email,
  phone,
  employeeCode,
  designationId,
  companyUnitId,
  joinDate,
  branch,
  district
) {
  var req = {
    rankId,
    companyId,
    firstName,
    lastName,
    email,
    phone,
    employeeCode,
    designationId,
    companyUnitId,
    joinDate,
    branch,
    district
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployee`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addEmployeeManager(req) {
  return fetch(
    `${config.apiurl}/employee/PostEmployeeManager`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addEmployeeManagerII(req) {
  return fetch(
    `${config.apiurl}/employee/PostEmployeeStage2Manager`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addOperationalEmployeeManager(req) {
  return fetch(
    `${config.apiurl}/employee/PostOperationalEmployeeManager`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addOperationalEmployeeManagerII(req) {
  return fetch(
    `${config.apiurl}/employee/PostOperationalEmployeeStage2Manager`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function exportAllLeaves(id, req) {
  return fetch(
    `${config.apiurl}/employee/ExportAllLeaves/${id}`,
    requestOptions.post(req)
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function exportCertificate(id, type) {
  return fetch(
    `${config.apiurl}/employee/Certificate/${id}?type=${type}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function getLookup(type) {
  return fetch(
    `${config.apiurl}/Miscellaneous/getLookup?type=${type}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function onboard(req) {
  return fetch(`${config.apiurl}/employee/Onboarding`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function exitEmployee(id, employeeId, typeId) {
  var req = {
    id,
    employeeId,
    typeId
  };
  return fetch(
    `${config.apiurl}/employee/exitEmployee`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function exitAutoEmployee(employeeId) {
  return fetch(
    `${config.apiurl}/employee/exitEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function reconsiderEmployee(employeeId) {
  return fetch(
    `${config.apiurl}/employee/ReconsiderEmployee?employeeId=${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getGroups() {
  return fetch(`${config.apiurl}/employee/getGroup`, requestOptions.get())
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function changeEmployeePhoto(file, id) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/employee/PostEmployeePhoto/${id}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function uploadFile(file, id) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/expense/PostFile`,
    requestOptions.postForm(formData)
  )
    .then(handleTextResponse)
    .then(id => {
      return id;
    });
}
function importEmployee(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/employee/importEmployee`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importEmployeeDetail(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/employee/importOtherDetail`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importLeaveEntitlement(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/company/importLeaveEntitlement`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function importOnboarding(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/employee/BulkOnboarding`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function importEmployeeSalary(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/employee/importEmployeeSalary`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function exportEmployee(id) {
  return fetch(
    `${config.apiurl}/employee/ExportEmployeesByUnit/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function exportAdvance(id) {
  return fetch(
    `${config.apiurl}/expense/ExportApprovedCashAdvance/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function exportClaim(id) {
  return fetch(
    `${config.apiurl}/expense/ExportApprovedExpenseClaim/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function exportEmployeeSalary(id) {
  return fetch(
    `${config.apiurl}/employee/ExportAllEmployeeSalaries/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function exportPrevEmployeeSalary(id, month, year) {
  return fetch(
    `${config.apiurl}/salary/ExportAllPayslipByPeriod/${id}?month=${month}&year=${year}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function exportAllTempPayslip(id) {
  return fetch(
    `${config.apiurl}/salary/ExportAllTempPayslipByPeriod/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function downloadEmployeeTemplate(id) {
  return fetch(
    `${config.apiurl}/employee/DownloadEmployeeTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function downloadEntitlementTemplate(id) {
  return fetch(
    `${config.apiurl}/company/DownloadEntitlementTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function downloadOnboardingTemplate(id) {
  return fetch(
    `${config.apiurl}/employee/DownloadOnboardingTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function downloadEmployeeSalaryTemplate(id) {
  return fetch(
    `${config.apiurl}/employee/DownloadEmployeeSalaryTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function addEmployeeExperience(
  employeeId,
  companyName,
  position,
  startYear,
  endYear
) {
  var req = {
    employeeId,
    companyName,
    position,
    startYear,
    endYear
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeExp`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeEducation(
  employeeId,
  institute,
  discipline,
  startYear,
  endYear
) {
  var req = {
    employeeId,
    institute,
    discipline,
    startYear,
    endYear
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeEducation`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeNextOfKin(
  employeeId,
  fullName,
  address,
  relationship,
  phone
) {
  var req = {
    employeeId,
    fullName,
    address,
    relationship,
    phone
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeNextOfKin`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeGLI(
  employeeId,
  fullName,
  address,
  relationship,
  percentage
) {
  var req = {
    employeeId,
    fullName,
    address,
    relationship,
    percentage
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeGLI`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeEmergency(
  employeeId,
  name,
  relationship,
  phone1,
  phone2,
  sname,
  srelationship,
  sphone1,
  sphone2
) {
  var req = {
    employeeId,
    name,
    relationship,
    phone1,
    phone2
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeEmergency`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      var req = {
        employeeId,
        name: sname,
        relationship: srelationship,
        phone1: sphone1,
        phone2: sphone2
      };

      return fetch(
        `${config.apiurl}/employee/PostEmployeeEmergency`,
        requestOptions.post(req)
      ).then(handleResponse);
    });
}

function addEmployeeBank(
  employeeId,
  bankAccountNumber,
  bankCode,
  bankName,
  bvnNumber
) {
  var req = {
    employeeId,
    bankAccountNumber,
    bankCode,
    bankName,
    bvnNumber
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeBank`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeLeavePolicy(policyId, payload) {
  return fetch(
    `${config.apiurl}/employee/PostEmployeeLeavePolicy/${policyId}`,
    requestOptions.post(payload)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeFamily(employeeId, name, relationship, phoneNo) {
  var req = {
    employeeId,
    name,
    relationship,
    phoneNo
  };
  return fetch(
    `${config.apiurl}/employee/PostEmployeeFamily`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeStatutory(employeeId, salary, pf, tax, nhf) {
  salary.employeeId = employeeId;
  pf.employeeId = employeeId;
  tax.employeeId = employeeId;
  nhf.employeeId = employeeId;
  fetch(`${config.apiurl}/employee/PostEmployeeTax`, requestOptions.post(tax));
  fetch(`${config.apiurl}/employee/PostEmployeeNHF`, requestOptions.post(nhf));
  return fetch(
    `${config.apiurl}/employee/PostEmployeeStatutory`,
    requestOptions.post(salary)
  )
    .then(handleResponse)
    .then(id => {
      fetch(
        `${config.apiurl}/employee/PostEmployeePension`,
        requestOptions.post(pf)
      );
      return id;
    });
}

function updateEmployee(id, req) {
  return fetch(
    `${config.apiurl}/employee/UpdateEmployee/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeePersonalInfo(id, model) {
  return fetch(
    `${config.apiurl}/employee/UpdateEmployee/${id}`,
    requestOptions.put(model)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateEmployeeStatutory(employeeId, salary, pf, tax, nhf) {
  salary.employeeId = employeeId;
  pf.employeeId = employeeId;
  tax.employeeId = employeeId;
  nhf.employeeId = employeeId;
  if (tax.id != 0) {
    fetch(
      `${config.apiurl}/employee/UpdateEmployeeTax/${tax.id}`,
      requestOptions.put(tax)
    );
  } else {
    fetch(
      `${config.apiurl}/employee/PostEmployeeTax`,
      requestOptions.post(tax)
    );
  }
  if (nhf.id != 0) {
    fetch(
      `${config.apiurl}/employee/UpdateEmployeeNHF/${nhf.id}`,
      requestOptions.put(nhf)
    );
  } else {
    fetch(
      `${config.apiurl}/employee/PostEmployeeNHF`,
      requestOptions.post(nhf)
    );
  }
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeStatutory/${salary.id}`,
    requestOptions.put(salary)
  )
    .then(handleResponse)
    .then(id => {
      if (pf.id != 0) {
        fetch(
          `${config.apiurl}/employee/UpdateEmployeePension/${pf.id}`,
          requestOptions.put(pf)
        );
      } else {
        fetch(
          `${config.apiurl}/employee/PostEmployeePension`,
          requestOptions.post(pf)
        );
      }
      return id;
    });
}
function updateEmployeeProfileInfo(id, model) {
  return fetch(
    `${config.apiurl}/employee/UpdateEmployee/${id}`,
    requestOptions.put(model)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeExperience(
  id,
  employeeId,
  companyName,
  position,
  startYear,
  endYear
) {
  var req = {
    employeeId,
    companyName,
    position,
    startYear,
    endYear
  };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeExperience/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeEducation(id, req) {
  // var req = {
  //   employeeId,
  //   institute,
  //   discipline,
  //   startYear,
  //   endYear
  // };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeEducation/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function deleteEmployeeEducation(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeEducation/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateEmployeeNextOfKin(
  id,
  employeeId,
  fullName,
  address,
  relationship,
  phone
) {
  var req = {
    employeeId,
    fullName,
    address,
    relationship,
    phone
  };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeNextOfKin/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeGLI(
  id,
  employeeId,
  fullName,
  address,
  relationship,
  percentage
) {
  var req = {
    employeeId,
    fullName,
    address,
    relationship,
    percentage
  };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeGLI/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeEmergency(
  id,
  employeeId,
  name,
  relationship,
  phone1,
  phone2,
  sid,
  sname,
  srelationship,
  sphone1,
  sphone2
) {
  var req = {
    employeeId,
    name,
    relationship,
    phone1,
    phone2
  };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeEmergency/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      var req = {
        employeeId,
        name: sname,
        relationship: srelationship,
        phone1: sphone1,
        phone2: sphone2
      };
      return fetch(
        `${config.apiurl}/employee/UpdateEmployeeEmergency/${sid}`,
        requestOptions.put(req)
      ).then(handleResponse);
    });
}

function updateEmployeeBank(id, req) {
  // var req = {
  //   employeeId,
  //   bankAccountNumber,
  //   bankCode,
  //   bankName,
  //   bvnNumber
  // };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeBank/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeFamily(id, employeeId, name, relationship, phoneNo) {
  var req = {
    employeeId,
    name,
    relationship,
    phoneNo
  };
  return fetch(
    `${config.apiurl}/employee/UpdateEmployeeFamily/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getEmployees(unitId) {
  return fetch(
    `${config.apiurl}/employee/Getemployeesbyunit/${unitId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getAllEmployees(cId) {
  return fetch(
    `${config.apiurl}/employee/Getallemployees/${cId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getManagers(unitId) {
    return fetch(
      `${config.apiurl}/employee/Getmanagers/${unitId}`,
      requestOptions.get()
    )
      .then(handleResponse)
      .then(model => {
        return model;
      });
  }

function getManager(id) {
    return fetch(
      `${config.apiurl}/employee/Getmanager/${id}`,
      requestOptions.get()
    )
      .then(handleResponse)
      .then(model => {
        return model;
      });
  }

function getOperationalManagers(unitId) {
    return fetch(
      `${config.apiurl}/employee/Getoperationalmanagers/${unitId}`,
      requestOptions.get()
    )
      .then(handleResponse)
      .then(model => {
        return model;
      });
  }

function getOperationalManager(id) {
    return fetch(
      `${config.apiurl}/employee/Getoperationalmanager/${id}`,
      requestOptions.get()
    )
      .then(handleResponse)
      .then(model => {
        return model;
      });
  }

function getEmployeesByDepart(unitId, departId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeesByDepart/${departId}?unitId=${unitId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getEmployeeById(Id) {
  return fetch(
    `${config.apiurl}/employee/Getemployee/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function GetProbatedEmployees(Id, unitId) {
  return fetch(
    `${config.apiurl}/Employee/GetProbatedEmployeesDepart/${Id}?unitId=${unitId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function updateProbatedEmployeeOnConfirmation(id, probatedEmployeeUpdate) {
  return fetch(
    `${config.apiurl}/Employee/UpdateProbatedEmployee/${id}`,
    requestOptions.put(probatedEmployeeUpdate)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function updateTransferedEmployee(id, transferedEmployeeUpdate) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeTransfer/${id}`,
    requestOptions.put(transferedEmployeeUpdate)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function confirmTransferedEmployee(id, transferedEmployeeUpdate) {
  return fetch(
    `${config.apiurl}/Employee/ConfirmEmployeeTransfer/${id}`,
    requestOptions.put(transferedEmployeeUpdate)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateProbatedEmployee(id, probatedEmployeeUpdate) {
  return fetch(
    `${config.apiurl}/Employee/UpdateProbatedEmployee/${id}`,
    requestOptions.put(probatedEmployeeUpdate)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function GetProbatedEmployeesByUnit(Id) {
  return fetch(
    `${config.apiurl}/Employee/GetProbatedEmployeesByUnit/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function GetTransferedEmployees(Id) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeTransferByUnitId/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function GetTransferedEmployeesByDepart(Id, unitId) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeTransferByDepartId/${Id}?unitId=${unitId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function GetTransferedEmployeesByIncoming(Id, unitId) {
  return fetch(
    `${config.apiurl}/Employee/GetIncomingEmployeeTransferByDepartId/${Id}?unitId=${unitId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function GetProbatedEmployeesExtension(Id) {
  return fetch(
    `${config.apiurl}/Employee/GetAllProbatedEmployeesExtension?id=${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addTransferedEmployee(data) {
  // let res = {
  //   employeeId,
  //   fromUnitId,
  //   toUnitId,
  //   toDesignationId,
  //   fromDesignationId,
  //   toRankId,
  //   fromRankId,
  //   employeeCode,
  //   dateJoined
  // };
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeTransfer`,
    requestOptions.post(data)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function extendProbationTo(
  updatedBy,
  comment,
  probatedEmployeeId,
  duration,
  requestDate,
  requestBy
) {
  let res = {
    updatedBy,
    comment,
    probatedEmployeeId,
    duration,
    requestDate,
    requestBy
  };
  return fetch(
    `${config.apiurl}/Employee/PostProbatedEmployeeExtension`,
    requestOptions.post(res)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateProbatedEmployeeExtension(id, probatedEmployeeUpdateExtension) {
  return fetch(
    `${config.apiurl}/employee/UpdateProbatedEmployeeExtension/${id}`,
    requestOptions.put(probatedEmployeeUpdateExtension)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getExitEmployees(companyId) {
  return fetch(
    `${config.apiurl}/employee/Getinactiveemployees/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getHires(companyId) {
  return fetch(
    `${config.apiurl}/employee/GetHires/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getHire(Id) {
  return fetch(`${config.apiurl}/employee/GetHire/${Id}`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getEmployeeLeaves(companyId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeLeaves/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeeDepartLeaves(companyId, empId, departId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeDepartLeaves/${companyId}?departId=${departId}&empId=${empId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeeDepartLoans(companyId, empId, departId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeDepartLoans/${companyId}?departId=${departId}&empId=${empId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeeLeaveSummary(employeeId) {
  return fetch(
    `${config.apiurl}/Summary/GetEmployeeLeaveSummaryByEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getHRLeaveSummary(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetLeaveCountSummary/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getDashboardCountSummary(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetDashboardCountSummary/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getTodayAbsence(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetTodayAbsence/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getTodayBirthdays(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetTodayBirthday/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getThirdRaterGoals(employeeId) {
  return fetch(
    `${config.apiurl}/Summary/GetThirdRaterGoals/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getUpcomingHolidays(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetUpcomingHolidays`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getRecentDiscipline(employeeId) {
  return fetch(
    `${config.apiurl}/Summary/GetRecentDiscipline/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getUpcomingBirthday(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetUpcomingBirthday/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getUpcomingLeaves(companyId) {
  return fetch(
    `${config.apiurl}/Summary/getUpcomingLeaves/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function grantEmployee(employeeId) {
  return fetch(
    `${config.apiurl}/Employee/grantEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getLastSalaryPayment(companyId) {
  return fetch(
    `${config.apiurl}/Summary/GetLastSalaryPayment/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getUpcomingResignations(companyId) {
  return fetch(
    `${config.apiurl}/Summary/getUpcomingResignations/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeeLeavesByEmployee(Id) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeLeavesByEmployee/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeeLeavesByManager(Id) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeLeavesByManager/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeePolicies(companyId) {
  return fetch(
    `${config.apiurl}/employee/GetCompanyLeavePolicies/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function deleteEmployeeLeavePolicy(id, res) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeLeavePolicy/${id}`,
    requestOptions.post(res)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getEmployeeLeaveEligibility(employeeId, typeId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeLeaveEligibility/${employeeId}?typeId=${typeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPrevAllowanceLeaves(employeeId) {
  return fetch(
    `${config.apiurl}/employee/getPrevAllowanceLeaves/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}


function removeEmployee(employeeId) {
  // console.log(employeeId)
  return fetch(
    `${config.apiurl}/employee/DeleteEmployee/${employeeId}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeEducation(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeEducation/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeGLI(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeGLI/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeNextOfKin(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeNextOfKin/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeePension(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeePension/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getEmployeeDetail(employeeId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getEmployeeOtherDetail(employeeId) {
  return fetch(
    `${config.apiurl}/employee/GetEmployeeOtherDetail/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeExperience(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeExperience/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeFamily(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeFamily/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function removeEmployeeEmergency(Id) {
  return fetch(
    `${config.apiurl}/employee/DeleteEmployeeEmergency/${Id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addEmployeeLeave(
  companyId,
  employeeId,
  fromDate,
  toDate,
  days,
  reason,
  leaveTypeId,
  approvedBy,
  status,
  needAllowance
) {
  var req = {
    companyId,
    employeeId,
    fromDate,
    toDate,
    days,
    reason,
    leaveTypeId,
    approvedBy,
    status: status,
    needAllowance
  };
  //console.log(req)
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeLeave`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addEmployeeAmedLeave(
  companyId,
  employeeLeaveId,
  amendDate,
  hodReason,
  requestedBy,
  requestedDate
) {
  var req = {
    companyId,
    employeeLeaveId,
    amendDate,
    hodReason,
    requestedBy,
    requestedDate
  };
  console.log(req);
  return fetch(
    `${config.apiurl}/Employee/PostLeaveAmendment`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getAmendedLeaves(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLeaveAmendments/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      console.log(model);
      return model;
    });
}

function getDepartAmendedLeaves(id, dId) {
  return fetch(
    `${config.apiurl}/Employee/GetDepartmentLeaveAmendments/${id}?departId=${dId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      console.log(model);
      return model;
    });
}

function getAmendedLeavesByManager(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLeaveAmendmentsByManager/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      console.log(model);
      return model;
    });
}

function updateLeaveAmendment(id, leave) {
  return fetch(
    `${config.apiurl}/Employee/ApproveLeaveAmendment/${id}`,
    requestOptions.put(leave)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeLeave(id, leave) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeLeave/${id}`,
    requestOptions.put(leave)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeEmployeeLeave(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeLeave/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getEmployeeTerminations(companyId) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeTerminations/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function addEmployeeTermination(
  date,
  reason,
  noticeDate,
  terminationTypeId,
  employeeId
) {
  var req = {
    date,
    reason,
    noticeDate,
    terminationTypeId,
    employeeId
  };
  //console.log(req)
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeTermination`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateEmployeeTermination(
  id,
  date,
  reason,
  noticeDate,
  terminationTypeId,
  employeeId
) {
  var req = {
    id,
    date,
    reason,
    noticeDate,
    terminationTypeId,
    employeeId
  };
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeTermination/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeEmployeeTermination(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeTermination/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeActivity(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeActivity/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeeResource(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeResource/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addEmployeeResignation(req) {
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeResignation`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeRetirement(retirementDate, reason, noticeDate, employeeId) {
  var req = {
    retirementDate,
    reason,
    noticeDate,
    employeeId
  };
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeRetirement`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addExitInterview(companyId, interview) {
  return fetch(
    `${config.apiurl}/Employee/PostExitInterview/${companyId}`,
    requestOptions.post(interview)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addExitDocument(companyId, resignationId, cv) {
  let formData = new FormData();
  formData.append("ResignationId", resignationId);
  formData.append("Uploadfile", cv);
  return fetch(
    `${config.apiurl}/Employee/PostExitDocument/${companyId}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function UpdateExitInterview(id, interview) {
  return fetch(
    `${config.apiurl}/Employee/UpdateExitInterview/${id}`,
    requestOptions.put(interview)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addRetireExitInterview(companyId, interview) {
  return fetch(
    `${config.apiurl}/Employee/PostRetireExitInterview/${companyId}`,
    requestOptions.post(interview)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addRetireExitDocument(companyId, resignationId, cv) {
  let formData = new FormData();
  formData.append("RetirementId", resignationId);
  formData.append("Uploadfile", cv);
  return fetch(
    `${config.apiurl}/Employee/PostRetireExitDocument/${companyId}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function UpdateRetireExitInterview(id, interview) {
  return fetch(
    `${config.apiurl}/Employee/UpdateRetireExitInterview/${id}`,
    requestOptions.put(interview)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function UpdateEmployeeActivity(id, payload) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeActivity/${id}`,
    requestOptions.put(payload)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function UpdateEmployeeOnboarding(id, payload) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeOnboarding/${id}`,
    requestOptions.put(payload)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function UpdateEmployeeResource(id, payload) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeResource/${id}`,
    requestOptions.put(payload)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getEmployeeResignations(companyId) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeResignations/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getEmployeeResignationsByEmployee(Id) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeResignationsByEmployee/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function removeEmployeeResignation(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeResignation/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateEmployeeResignation(id, resignation) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeResignation/${id}`,
    requestOptions.put(resignation)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getEmployeeRetirements(companyId) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeRetirements/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getEmployeeRetirementsByEmployee(Id) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeRetirementsByEmployee/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function removeEmployeeRetirement(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeRetirement/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateEmployeeRetirement(id, retirement) {
  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeRetirement/${id}`,
    requestOptions.put(retirement)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function completeExpenses(req) {
  return fetch(
    `${config.apiurl}/Expense/CompleteExpenseClaim`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function completeCashAdvance(req) {
  return fetch(
    `${config.apiurl}/Expense/CompleteCashAdvance`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeePromotion(from, to, date, employeeId, companyId) {
  var req = {
    from,
    to,
    date,
    employeeId,
    companyId
  };
  return fetch(
    `${config.apiurl}/Employee/PostEmployeePromotion`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPromotions(companyid) {
  return fetch(
    `${config.apiurl}/Employee/GetPromotions/${companyid}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeEmployeePromotion(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeePromotion/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateEmployeePromotion(from, to, date, employeeId, companyId) {
  var req = {
    from,
    to,
    date,
    employeeId,
    companyId
  };
  return fetch(
    `${config.apiurl}/Employee/PutEmployeePromotion`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addExpenseType(companyId, name, glAccount) {
  var req = {
    companyId,
    name,
    glAccount
  };
  //console.log(req)
  return fetch(
    `${config.apiurl}/Expense/PostExpenseType`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addExpenseClaim(req) {
  return fetch(
    `${config.apiurl}/Expense/PostExpenseClaim`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addExpenseClaimItem(req) {
  return fetch(
    `${config.apiurl}/Expense/PostExpenseClaimItem`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addLoanType(req) {
  return fetch(
    `${config.apiurl}/Employee/PostLoanType`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addLoanRequest(req) {
  return fetch(
    `${config.apiurl}/Employee/PostLoanRequest`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addLoans(req) {
  return fetch(
    `${config.apiurl}/Employee/PostLoans`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function calculateLoan(req) {
  return fetch(
    `${config.apiurl}/Employee/CalculateLoan`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function checkLoan(req) {
  return fetch(
    `${config.apiurl}/Employee/CheckLoan`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function getAmountByLoanType(id, pid) {
  return fetch(
    `${config.apiurl}/Employee/GetAmountByLoanType/${id}?parentId=${pid}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addCashAdvance(req) {
  return fetch(
    `${config.apiurl}/Expense/PostCashAdvance`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addStoreRequisition(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/CreateStoreRequisition`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addStoreRequisitionItem(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/CreateStoreRequisitionItem`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addPurchaseRequisition(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/CreatePurchaseRequisition`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addPurchaseRequisitionItem(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/CreatePurchaseRequisitionItem`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addCashRetirement(req) {
  return fetch(
    `${config.apiurl}/Expense/PostCashRetirement`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addCashRetirementLine(req) {
  return fetch(
    `${config.apiurl}/Expense/PostCashRetirementLine`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addCashRetirementLink(req) {
  return fetch(
    `${config.apiurl}/Expense/PostCashRetirementLink`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateExpenseClaim(req) {
  return fetch(
    `${config.apiurl}/Expense/PutExpenseClaim`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function approveExpenseClaim(req) {
  return fetch(
    `${config.apiurl}/Expense/ApproveExpenseClaim`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function approveEmployeeLeave(req) {
  return fetch(
    `${config.apiurl}/Employee/ApproveEmployeeLeave`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function approveLoanRequest(req) {
  return fetch(
    `${config.apiurl}/Employee/ApproveLoanRequest`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateLoanType(req) {
  return fetch(
    `${config.apiurl}/Employee/UpdateLoanType`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateLoanRequest(id, req) {
  return fetch(
    `${config.apiurl}/Employee/UpdateLoanRequest/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function UpdateLoanToPayroll(id, req) {
  return fetch(
    `${config.apiurl}/Employee/ApproveLoanRequest/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateExpenseClaimItem(req) {
  return fetch(
    `${config.apiurl}/Expense/PutExpenseClaimItem`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function adjustExpenseClaimItems(req) {
  return fetch(
    `${config.apiurl}/Expense/AdjustExpenseClaimItem`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateCashAdvance(req) {
  return fetch(
    `${config.apiurl}/Expense/PutCashAdvance`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function approveCashAdvance(req) {
  return fetch(
    `${config.apiurl}/Expense/ApproveCashAdvance`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateStoreRequisition(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/UpdateStoreRequisition`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateStoreRequisitionItem(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/UpdateStoreRequisitionItem`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updatePurchaseRequisition(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/UpdatePurchaseRequisition`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updatePurchaseRequisitionItem(req) {
  return fetch(
    `${config.apiurl}/Miscellaneous/UpdatePurchaseRequisitionItem`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateCashRetirement(req) {
  return fetch(
    `${config.apiurl}/Expense/PutCashRetirement`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateCashRetirementLine(req) {
  return fetch(
    `${config.apiurl}/Expense/PutCashRetirementLine`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateCashRetirementLink(req) {
  return fetch(
    `${config.apiurl}/Expense/PutCashRetirementLink`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateExpenseType(req) {
  //console.log(req)
  return fetch(
    `${config.apiurl}/Expense/PutExpenseType`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function getLoanTypes(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLoanTypes/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getLoanRequestsByEmployee(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLoanRequestByEmployeeId/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getLoanRequestsByUnit(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLoanRequestByUnitId/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCurrentLoanRequestsByUnit(id) {
  return fetch(
    `${config.apiurl}/Employee/GetRecentLoanRequestByUnitId/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getLoanRequestsByTeam(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLoanRequestByTeam/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getLoanRequests(id) {
  return fetch(
    `${config.apiurl}/Employee/GetAllLoanRequest/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getBankAccounts() {
  return fetch(
    `${config.apiurl}/company/GetBankAccounts`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getExpenseClaimByEmployee(id) {
  return fetch(
    `${config.apiurl}/Expense/GetExpenseClaimByEmployee/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getExpenseClaimByTeam(id) {
  return fetch(
    `${config.apiurl}/Expense/GetExpenseClaimByTeam/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getExpenseClaimByUnit(id) {
  return fetch(
    `${config.apiurl}/Expense/GetExpenseClaimByUnit/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getExpenseClaims(id) {
  return fetch(
    `${config.apiurl}/Expense/GetExpenseClaims/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getApprovedExpenseClaims(id) {
  return fetch(
    `${config.apiurl}/Expense/GetApprovedExpenseClaims/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCompletedExpenseClaims(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCompletedExpenseClaims/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPostedExpenseClaims(id) {
  return fetch(
    `${config.apiurl}/Expense/GetPostedExpenseClaims/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashAdvanceByEmployee(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashAdvanceByEmployee/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashAdvanceByTeam(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashAdvanceByTeam/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashAdvanceByUnit(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashAdvanceByUnit/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashAdvances(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashAdvances/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getApprovedCashAdvances(id) {
  return fetch(
    `${config.apiurl}/Expense/GetApprovedCashAdvances/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCompletedCashAdvances(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCompletedCashAdvances/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPostedCashAdvances(id) {
  return fetch(
    `${config.apiurl}/Expense/GetPostedCashAdvances/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getStoreRequisitionByEmployee(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetStoreRequisitionByEmployee?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getStoreRequisitionByTeam(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetStoreRequisitionByTeam?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getStoreRequisitions(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetStoreRequisitions?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPurchaseRequisitionByEmployee(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetPurchaseRequisitionByEmployee?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPurchaseRequisitionByTeam(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetPurchaseRequisitionByTeam?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPurchaseRequisitions(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetPurchaseRequisitions?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getProducts() {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetProducts`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashRetirementByUnit(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashRetirementByUnit/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashRetirementByTeam(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashRetirementByTeam/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getExpenseClaimById(id) {
  return fetch(
    `${config.apiurl}/Expense/GetExpenseClaimById/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCashAdvanceById(id) {
  return fetch(
    `${config.apiurl}/Expense/GetCashAdvanceById/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getStoreRequisitionById(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetStoreRequisitionById?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getPurchaseRequisitionById(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/GetPurchaseRequisitionById?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getExpenseType(id) {
  return fetch(
    `${config.apiurl}/Expense/GetExpenseType/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function removeExpenseClaim(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteExpenseClaim/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeExpenseClaimItem(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteExpenseClaimItem?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeCashRetirement(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteCashRetirement/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeCashRetirementLine(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteCashRetirementLine/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeCashRetirementLink(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteCashRetirementLink/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeCashAdvance(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteCashAdvance/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeStoreRequisition(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/DeleteStoreRequisition?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeStoreRequisitionItem(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/DeleteStoreRequisitionItem?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removePurchaseRequisition(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/DeletePurchaseRequisition?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removePurchaseRequisitionItem(id) {
  return fetch(
    `${config.apiurl}/Miscellaneous/DeletePurchaseRequisitionItem?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeExpenseType(id) {
  return fetch(
    `${config.apiurl}/Expense/DeleteExpenseType/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeLoanType(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteLoanType/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function removeLoanRequest(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteLoanRequest/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function addEmployeeSalary(
  basic,
  hra,
  ma,
  pf,
  leave,
  allowance,
  leaveAllowance,
  hmo,
  tax,
  netSalary,
  conveyance,
  labourWalfare,
  employeeId
) {
  var req = {
    basic,
    hra,
    ma,
    pf,
    leave,
    allowance,
    leaveAllowance,
    hmo,
    tax,
    netSalary,
    conveyance,
    labourWalfare,
    employeeId
  };
  return fetch(
    `${config.apiurl}/employee/postEmployeeSalary`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getEmployeeSalary(id) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeSalary/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function isEmployeeManager() {
  return fetch(
    `${config.apiurl}/Employee/IsEmployeeManager`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function isOperationalEmployeeManager() {
  return fetch(
    `${config.apiurl}/Employee/IsOperationalEmployeeManager`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function checkMgt(id) {
  return fetch(`${config.apiurl}/Employee/checkMgt/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getDesignation(id) {
  return fetch(
    `${config.apiurl}/Designation/GetDesignationByEmployee?id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getEmployeeSalaries(id) {
  return fetch(
    `${config.apiurl}/Employee/GetallEmployeeSalaries/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getallEmployeeSalaries(id, month, year) {
  return fetch(
    `${config.apiurl}/Employee/GetallPrevEmployeeSalaries/${id}?month=${month}&year=${year}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateEmployeeSalary(
  id,
  basic,
  hra,
  ma,
  pf,
  leave,
  allowance,
  leaveAllowance,
  hmo,
  tax,
  netSalary,
  conveyance,
  labourWalfare,
  employeeId
) {
  var req = {
    basic,
    hra,
    ma,
    pf,
    leave,
    allowance,
    leaveAllowance,
    hmo,
    tax,
    netSalary,
    conveyance,
    labourWalfare,
    employeeId
  };

  return fetch(
    `${config.apiurl}/Employee/UpdateEmployeeSalary/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeEmployeeSalary(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteEmployeeSalary/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeLeaveEntitlement(id) {
  return fetch(
    `${config.apiurl}/Company/DeleteEntitlement?id=${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getPaidSalaries(id) {
  return fetch(
    `${config.apiurl}/Employee/GetPaidSalaries/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function addDisciplinaryMeasure(req) {
  return fetch(
    `${config.apiurl}/Employee/PostDisciplinaryMeasure`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addDisciplinaryCase(
  companyId,
  title,
  date,
  accusation,
  reason,
  remark,
  employeeId,
  accusedEmployees
) {
  var req = {
    companyId,
    title,
    date,
    accusation,
    reason,
    remark,
    employeeId,
    accusedEmployees
  };
  return fetch(
    `${config.apiurl}/Employee/PostDisciplinaryCase`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeActivity(employeeId, activityId, dueDate) {
  var req = {
    employeeId,
    activityId,
    dueDate
  };
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeActivity`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeResource(employeeId, resourceId) {
  var req = {
    employeeId,
    resourceId
  };
  return fetch(
    `${config.apiurl}/Employee/PostEmployeeResource`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getDisciplinaryMeasureByEmployeeId(employeeId) {
  return fetch(
    `${config.apiurl}/Employee/GetDisciplinaryMeasureByEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getDisciplinaryMeasures(companyId) {
  return fetch(
    `${config.apiurl}/Employee/GetDisciplinaryMeasures/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getDisciplinaryCaseByEmployeeId(employeeId) {
  return fetch(
    `${config.apiurl}/Employee/GetDisciplinaryCaseByEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getDisciplinaryCases(companyId) {
  return fetch(
    `${config.apiurl}/Employee/GetDisciplinaryCases/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateDisciplinaryMeasure(id, date, form, reason, remark, employeeId) {
  var req = {
    id,
    date,
    form,
    reason,
    remark,
    employeeId
  };
  return fetch(
    `${config.apiurl}/Employee/UpdateDisciplinaryMeasure/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDisciplinaryMeasure(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteDisciplinaryMeasure/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function updateDisciplinaryCase(req) {
  return fetch(
    `${config.apiurl}/Employee/UpdateDisciplinaryCase/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeDisciplinaryCase(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteDisciplinaryCase/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addQuery(date, form, queryType, accusation, remark, employeeId) {
  var req = {
    date,
    form,
    queryType,
    accusation,
    remark,
    employeeId
  };
  return fetch(`${config.apiurl}/Employee/PostQuery`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getQuery(employeeId) {
  return fetch(
    `${config.apiurl}/Employee/GetQueriesByEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getQueries(companyId) {
  return fetch(
    `${config.apiurl}/Employee/GetQueries/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateQuery(
  id,
  date,
  form,
  queryType,
  accusation,
  remark,
  employeeId
) {
  var req = {
    id,
    date,
    form,
    queryType,
    accusation,
    remark,
    employeeId
  };
  return fetch(
    `${config.apiurl}/Employee/UpdateQuery/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeQuery(id) {
  return fetch(
    `${config.apiurl}/Employee/DeleteQuery/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function queryResponse(id, query) {
  return fetch(
    `${config.apiurl}/Employee/UpdateQuery/${id}`,
    requestOptions.put(query)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getLeavesApprovals(id) {
  return fetch(
    `${config.apiurl}/Employee/GetEmployeeLeaveApprovalsByManager/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getLoanApprovals(id) {
  return fetch(
    `${config.apiurl}/Employee/GetLoanApprovalsByManager/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}



// WEBPACK FOOTER //
// ./src/services/employeeService.js